import React from "react";
import { useLang } from "../i18n/LangContext";
import bbsnLogo from "../assets/partners/bbsn-2026.png";
import erasmusLogo from "../assets/partners/erasmus.png";
import englishUkLogo from "../assets/partners/english-uk.png";
import qsLogo from "../assets/partners/qs-rankings.png";
import shorelightLogo from "../assets/partners/shorelight.png";
import csgLogo from "../assets/partners/csg.png";
import alpadiaLogo from "../assets/partners/alpadia.png";
import navitasLogo from "../assets/partners/navitas.png";
import inspiredLogo from "../assets/partners/inspired.png";
import educoLogo from "../assets/partners/educo.png";
import intoLogo from "../assets/partners/into.png";
import oncampusLogo from "../assets/partners/oncampus.png";
import kaplanLogo from "../assets/partners/kaplan.png";
import nordAngliaLogo from "../assets/partners/nord-anglia.png";
import swissEducationLogo from "../assets/partners/swiss-education.png";

import sommetLogo from "../assets/partners/sommet.png";
import ucasLogo from "../assets/partners/ucas.png";
import gusLogo from "../assets/partners/gus.png";
import geduLogo from "../assets/partners/gedu.png";
import studytravelLogo from "../assets/partners/studytravel.png";

const partners = [
  { name: "British Boarding Schools Network", src: bbsnLogo },
  { name: "Erasmus+", src: erasmusLogo },
  { name: "English UK", src: englishUkLogo },
  { name: "QS World University Rankings", src: qsLogo },
  { name: "Shorelight Education", src: shorelightLogo },
  { name: "Cognita Schools Group", src: csgLogo },
  { name: "Alpadia Language Schools", src: alpadiaLogo },
  { name: "Navitas", src: navitasLogo },
  { name: "Inspired Education", src: inspiredLogo },
  { name: "Educo", src: educoLogo },
  { name: "INTO University Partnerships", src: intoLogo },
  { name: "ONCAMPUS — Cambridge Education Group", src: oncampusLogo },
  { name: "Kaplan International Pathways", src: kaplanLogo },
  { name: "Nord Anglia Education", src: nordAngliaLogo },
  { name: "Swiss Education", src: swissEducationLogo },
  { name: "Sommet Education", src: sommetLogo },
  { name: "UCAS", src: ucasLogo },
  { name: "Global University Systems", src: gusLogo },
  { name: "g'edu Global Education", src: geduLogo },
  { name: "StudyTravel", src: studytravelLogo }
];

const TITLES = {
  uk: 'Офіційні партнери',
  ru: 'Официальные партнёры',
  en: 'Official Partners',
  ar: 'الشركاء الرسميون',
  it: 'Partner Ufficiali',
  zh: '官方合作伙伴',
  es: 'Socios Oficiales',
  pl: 'Oficjalni partnerzy'
};

const Partners = () => {
  const { lang } = useLang();
  const title = TITLES[lang] || TITLES.uk;
  return (
    <section id="partners" className="py-20 md:py-24" style={{ background: '#FFFFFF', borderTop: '1px solid #E8E0D5', borderBottom: '1px solid #E8E0D5' }} data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14">
          <div className="eyebrow mb-3">Partners</div>
          <h2 className="headline-huge text-3xl md:text-4xl" style={{ color: '#1B2A4A' }}>{title}</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-x-8 gap-y-10 items-center justify-items-center max-w-6xl mx-auto">
          {partners.map((p) => (
            <div
              key={p.name}
              className="h-24 md:h-28 w-full flex items-center justify-center px-3 group"
              title={p.name}
              data-testid={`partner-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            >
              <img
                src={p.src}
                alt={p.name}
                className="max-h-full max-w-full object-contain transition duration-500 opacity-90 group-hover:opacity-100 group-hover:scale-105"
                draggable={false}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
